document.documentElement.classList.remove('no-js');
(function(){
  const header=document.querySelector('[data-enl-header]');
  const toggle=document.querySelector('[data-menu-toggle]');
  const mobile=document.querySelector('[data-mobile-nav]');
  function onScroll(){ if(header) header.classList.toggle('is-scrolled',window.scrollY>40); }
  onScroll(); window.addEventListener('scroll',onScroll,{passive:true});
  if(toggle&&mobile){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));mobile.classList.toggle('is-open',!open);});}
  const toast=document.createElement('div');toast.className='enl-toast';document.body.appendChild(toast);
  document.querySelectorAll('.enl-ajax-cart').forEach(form=>form.addEventListener('submit',async(e)=>{
    e.preventDefault(); const btn=form.querySelector('button'); if(btn) btn.disabled=true;
    try{const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)}); if(!res.ok) throw new Error('Cart error');
      const cart=await fetch('/cart.js').then(r=>r.json());document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.hidden=cart.item_count===0;});
      toast.textContent='Added to cart';toast.classList.add('is-visible');setTimeout(()=>toast.classList.remove('is-visible'),2200);
    }catch(err){window.location.href='/cart';}finally{if(btn) btn.disabled=false;}
  }));
})();
